// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.jumbo[data-v-26e6dd75] {

    position: relative;

    width: 100%;

    overflow: hidden
}
@media (min-width: 996px) {
.jumbo.sm[data-v-26e6dd75] {

        height: 16rem
}
.jumbo.md[data-v-26e6dd75] {

        height: 24rem
}
.jumbo.lg[data-v-26e6dd75] {

        height: 36rem
}
.jumbo.full[data-v-26e6dd75] {

        height: 100%
}
}
.jumbo.screen[data-v-26e6dd75] {

    height: 100vh;

    overflow: auto
}
.jumbo__background[data-v-26e6dd75] {

    position: absolute;

    top: 0;

    bottom: 0;

    left: 0;

    right: 0;

    z-index: 1
}
.jumbo__content[data-v-26e6dd75] {

    position: relative;

    z-index: 2;

    display: flex;

    height: 100%;

    width: 100%;

    flex-direction: column;

    align-items: center;

    justify-content: space-around;

    gap: 1.5rem;

    padding: 2.5rem
}
@media (min-width: 996px) {
.jumbo__content[data-v-26e6dd75] {

        flex-direction: row
}
}
.jumbo__content.spaced[data-v-26e6dd75] {

    gap: 2rem;

    padding: 4rem
}
@media (min-width: 996px) {
.jumbo__content.spaced[data-v-26e6dd75] {

        padding: 5rem
}
}
.jumbo__content.reverseOnMobile[data-v-26e6dd75] {

    flex-direction: column-reverse
}
@media (min-width: 996px) {
.jumbo__content.reverseOnMobile[data-v-26e6dd75] {

        flex-direction: row
}
}
.jumbo__content--before[data-v-26e6dd75] {

    font-family: Mont;

    line-height: 1;

    font-size: 2.5rem;

    font-weight: 700
}
@media (min-width: 996px) {
.jumbo__content--before[data-v-26e6dd75] {

        font-family: Mont;

        line-height: 1;

        font-size: 3.125rem;

        font-weight: 700
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/layout/Jumbo.vue"],"names":[],"mappings":";AA6CA;;IAAA,kBAAA;;IAAA,WAAA;;IAAA;AAAA;AAGA;AAAA;;QAAA;AAAA;AAIA;;QAAA;AAAA;AAIA;;QAAA;AAAA;AAIA;;QAAA;AAAA;AAZA;AAgBA;;IAAA,aAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,MAAA;;IAAA,SAAA;;IAAA,OAAA;;IAAA,QAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,UAAA;;IAAA,aAAA;;IAAA,YAAA;;IAAA,WAAA;;IAAA,sBAAA;;IAAA,mBAAA;;IAAA,6BAAA;;IAAA,WAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,SAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,iBAAA;;IAAA,cAAA;;IAAA,iBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA,cAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <div :class=\"['jumbo', size]\">\n    <!-- Background -->\n    <div class=\"jumbo__background\">\n      <slot name=\"background\" />\n    </div>\n\n    <!-- Content -->\n    <div :class=\"['jumbo__content', { spaced, reverseOnMobile }]\">\n      <!-- Before -->\n      <div class=\"jumbo__content--before\">\n        <slot name=\"before\" />\n      </div>\n\n      <!-- After -->\n      <div class=\"jumbo__content--after\">\n        <slot name=\"after\" />\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  props: {\n    size: {\n      type: String,\n      default: 'lg',\n    },\n\n    spaced: {\n      type: Boolean,\n      default: false,\n    },\n\n    reverseOnMobile: {\n      type: Boolean,\n      default: false,\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n.jumbo {\n  @apply relative w-full overflow-hidden;\n\n  &.sm {\n    @apply lg:h-[16rem];\n  }\n\n  &.md {\n    @apply lg:h-[24rem];\n  }\n\n  &.lg {\n    @apply lg:h-[36rem];\n  }\n\n  &.full {\n    @apply lg:h-full;\n  }\n\n  &.screen {\n    @apply h-screen overflow-auto;\n  }\n\n  &__background {\n    @apply absolute top-0 bottom-0 left-0 right-0 z-[1];\n  }\n\n  &__content {\n    @apply relative w-full h-full flex flex-col lg:flex-row justify-around items-center p-sm gap-xxs z-[2];\n\n    &.spaced {\n      @apply p-xl lg:p-xxl gap-xs;\n    }\n\n    &.reverseOnMobile {\n      @apply flex-col-reverse lg:flex-row;\n    }\n\n    &--before {\n      @apply style-title-bold lg:style-headline-bold;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
